import { render } from "./CombinationsTable.vue?vue&type=template&id=113adbd7"
import script from "./CombinationsTable.vue?vue&type=script&lang=js"
export * from "./CombinationsTable.vue?vue&type=script&lang=js"

import "./CombinationsTable.vue?vue&type=style&index=0&id=113adbd7&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__